import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MasksModule } from 'src/app/global/masks/masks.module';
import { NovoDashboardRoutingModule } from './novo-dashboard-routing.module';
import { DashboardSegmentosClientesComponent } from './dashboard-segmentos-clientes/dashboard-segmentos-clientes.component';
import { DashboardEstadosClientesComponent } from './dashboard-estados-clientes/dashboard-estados-clientes.component';
import { DashboardHistoricoCreditosComponent } from './dashboard-historico-creditos/dashboard-historico-creditos.component';
import { DashboardHistoricoInadiplenciaComponent } from './dashboard-historico-inadiplencia/dashboard-historico-inadiplencia.component';
import { DashboardPagamentosPorClientesComponent } from './dashboard-pagamentos-por-clientes/dashboard-pagamentos-por-clientes.component';
import { DashboardParcelasPagasVencidasComponent } from './dashboard-parcelas-pagas-vencidas/dashboard-parcelas-pagas-vencidas.component';
import { DashboardRenovacaoCreditoComponent } from './dashboard-renovacao-credito/dashboard-renovacao-credito.component';
import { DashboardCrescimentoBaseClientesComponent } from './dashboard-crescimento-base-clientes/dashboard-crescimento-base-clientes.component';
import { DashboardVolumeCreditoMensalComponent } from './dashboard-volume-credito-mensal/dashboard-volume-credito-mensal.component';
import { DashboardComparativosHistoricosComponent } from './dashboard-comparativos-historicos/dashboard-comparativos-historicos.component';
import { DashboardNovatosCobrancasRenovacoesComponent } from './dashboard-novatos-cobrancas-renovacoes/dashboard-novatos-cobrancas-renovacoes.component';

@NgModule({
  declarations: [
    DashboardSegmentosClientesComponent,
    DashboardEstadosClientesComponent,
    DashboardHistoricoCreditosComponent,
    DashboardHistoricoInadiplenciaComponent,
    DashboardPagamentosPorClientesComponent,
    DashboardParcelasPagasVencidasComponent,
    DashboardRenovacaoCreditoComponent,
    DashboardCrescimentoBaseClientesComponent,
    DashboardVolumeCreditoMensalComponent,
    DashboardComparativosHistoricosComponent,
    DashboardNovatosCobrancasRenovacoesComponent
  ],
  imports: [
    CommonModule,
    NovoDashboardRoutingModule,
    FormsModule,
    MasksModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class NovoDashboardModule { }
